import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const IndirSaleLineList = ({ indirSaleObj: indirSale }) => {
  
  const augRowsReq = useCallback((rowsReq) => {
    if (!indirSale) return;

    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('indirSaleId', indirSale.id, 
      'rcvdPeriodId', indirSale.rcvdPeriodId));
  }, []);

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons); 
  }

  return (
    <EntityList entity="INDIR_SALE_LINE" augRowsReq={augRowsReq} augTabButtons={augTabButtons}/>
  )
}
